import { BracketsRender } from '@/components/tournaments/brackets-render';
import { useRouteLoaderData } from 'react-router';
import { Field, FieldLabel } from '@repo/ui/components/field';
import { Button } from '@repo/ui/components/button';
import { idPublicTournamentIndex } from './layout';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { publicTournamentCategoryId, publicTournamentStage } from '@/stores/public-tournament';

function Active() {
  const { tournament } = useRouteLoaderData(idPublicTournamentIndex);

  const [categoryId, setCategoryId] = useAtom(publicTournamentCategoryId);
  const [stage, setStage] = useAtom(publicTournamentStage);

  useEffect(() => {
    // Check if the stored categoryId exists in the current tournament's categories
    const categoryExists = tournament?.categories?.some(
      (category: Category) => category.id.toString() === categoryId
    );

    if (!categoryId || !categoryExists) {
      setCategoryId(tournament?.categories?.[0]?.id?.toString());
    }
    if (!stage) {
      setStage('groups');
    }
  }, [categoryId, stage, tournament]);

  const category = tournament?.categories?.find((category: Category) => category.id === categoryId);

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="flex flex-col gap-4">
        <Field>
          <FieldLabel>Categoría</FieldLabel>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {tournament?.categories?.map((category: Category) => {
              const isSelected = categoryId === category.id.toString();
              return (
                <Button
                  key={category.id}
                  variant={isSelected ? 'default' : 'outline'}
                  onClick={() => setCategoryId(category.id.toString())}
                  className="w-full justify-start text-left h-auto py-3 px-4"
                >
                  {category.name}
                </Button>
              );
            })}
          </div>
        </Field>
        {categoryId && (
          <Field>
            <FieldLabel>Etapa</FieldLabel>
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant={stage === 'groups' ? 'default' : 'secondary'}
                onClick={() => setStage('groups')}
                className="w-full"
              >
                Grupos
              </Button>
              <Button
                variant={stage === 'elimination' ? 'default' : 'secondary'}
                onClick={() => setStage('elimination')}
                className="w-full"
              >
                Eliminación
              </Button>
            </div>
          </Field>
        )}
      </div>
      {categoryId && category && (
        <div className="flex-1 flex flex-col space-y-4">
          {stage === 'groups' ? (
            <BracketsRender
              data={category?.groupStage}
              categoryId={categoryId}
              tournament={tournament}
              club={tournament.club}
              readonly
            />
          ) : (
            <BracketsRender
              data={category?.eliminationStage}
              categoryId={categoryId}
              tournament={tournament}
              club={tournament.club}
              readonly
            />
          )}
        </div>
      )}
    </div>
  );
}

export const route = {
  index: true,
  path: 'active',
  element: <Active />,
};
